import { Box, FormErrorMessage, SimpleGrid } from "@chakra-ui/react";
import { LabelGroup } from "pages/RefProductInter/LabelGroup";
import { ButtonStyled } from "styled/Buttons.styled";

import { useSelector } from "react-redux";
import { NumericFormat } from "react-number-format";
//import { useForm } from "react-hook-form";
import { isObject, isString, isValid } from "utils/type-check-utils";
import { useEffect, useState } from "react";
import { parseFloat } from "utils/parseFloat";
import { useGlobalContext } from "context/GlobalContext";
import { RETURN_TYPES, useForm } from "hooks/useForm";
import { Regex } from "utils/Regex";
import Swal from 'sweetalert2';
const FormAddOtherCostOP = ({ onSubmit = () => {}, onCloseModal }) => {
  const { decimal_values_precision } = useSelector(
    (state) => state.auth.dataUser
  );
  const { dataToEditOP } = useGlobalContext();
  const [errors, setErrors] = useState({});

  const validateForm = () => {
    const newErrors = {};

    // Validación de descripción
    if (!name_other_cost || !name_other_cost.trim()) {
      newErrors.name_other_cost = "La descripción es requerida";
    }

    // Validación de peso en kilos
    console.log("net_weight_kilo_other_cost", net_weight_kilo_other_cost);
    if (
      net_weight_kilo_other_cost === "" ||
      net_weight_kilo_other_cost === null ||
      isNaN(net_weight_kilo_other_cost) ||
      Number(net_weight_kilo_other_cost) < 0
    ) {
      newErrors.net_weight_kilo_other_cost = "El peso en kilos debe ser mayor o igual a 0";
    }

    // Validación de valor total
    console.log("total_calculated_other_cost", total_calculated_other_cost);
    if (
      total_calculated_other_cost === "" ||
      total_calculated_other_cost === null ||
      isNaN(total_calculated_other_cost) ||
      Number(total_calculated_other_cost) < 0
    ) {
      newErrors.total_calculated_other_cost = "El valor total debe ser mayor o igual a 0";
    }

    // Validación especial: ambos en cero
    if (
      (Number(total_calculated_other_cost) === 0 || total_calculated_other_cost === "" || total_calculated_other_cost === null) &&
      (Number(net_weight_kilo_other_cost) === 0 || net_weight_kilo_other_cost === "" || net_weight_kilo_other_cost === null)
    ) {
      newErrors.total_calculated_other_cost = "El peso en kilos o el valor total deben ser mayor a 0";
    }

    setErrors(newErrors);

    // Mostrar todos los errores en un solo alert si hay alguno
    if (Object.keys(newErrors).length > 0) {
      Swal.fire({
        title: "Error",
        html: Object.values(newErrors).map(msg => `<div>${msg}</div>`).join(""),
        icon: "error",
      });
      return false;
    }

    return true;
  };

  const onFieldChange = (name, value) => {
    // Clear error when field is modified
    if (errors[name]) {
      setErrors(prev => ({...prev, [name]: null}));
    }
  };

  const { values, handleInputChange, reset, setValues } = useForm({
    initialState: {
      id: "",
      net_weight_kilo_other_cost: 0,
      total_calculated_other_cost: 0,
      quantity_other_cost: "",
      name_other_cost: "",
    },
    returnType: RETURN_TYPES.OBJECT,
    onFieldChange,
  });

  const {
    id,
    net_weight_kilo_other_cost,
    total_calculated_other_cost,
    quantity_other_cost,
    name_other_cost,
  } = values || {};

  const createOtherCost = () => {
    if (validateForm()) {
      onSubmit(values);
    }
  };

  const updateItemValue = (newValue, sourceEvent) => {
    const target = {
      ...sourceEvent?.event,
      [sourceEvent?.event?.target?.name]: newValue?.floatValue,
    };

    handleInputChange(target);
  };

  const handleRegex = ({ target }, type, regex) => {
    const { value } = target;
    if (!regex.test(value)) {
      setErrors(prev => ({
        ...prev,
        [target.name]: `Este campo solo acepta ${type}`
      }));
      return;
    }
    handleInputChange(target);
  };

  useEffect(() => {
    if (dataToEditOP) {
      setValues((prev) => ({
        ...prev,
        id: dataToEditOP?.id,
        net_weight_kilo_other_cost: isValid(dataToEditOP?.net_weight_cost)
          ? parseFloat(dataToEditOP?.net_weight_cost)
          : 0,
        total_calculated_other_cost: isValid(dataToEditOP?.total_us_other_cost)
          ? parseFloat(dataToEditOP?.total_us_other_cost)
          : 0,
        quantity_other_cost: isValid(dataToEditOP?.quantity_cost)
          ? parseFloat(dataToEditOP?.quantity_cost)
          : 0,
        name_other_cost: isValid(dataToEditOP?.name_cost)
          ? dataToEditOP?.name_cost
          : "",
      }));
    }
  }, [dataToEditOP]);

  return (
    <>
      <SimpleGrid minChildWidth="200px" spacing="10px" className="mt-3">
        <div>
          <LabelGroup
            name={"name_other_cost"}
            placeholder={"Descripción"}
            tag={"Descripción"}
            size={100}
            desicion={false}
            maxLength={5000}
            required={true}
            onChange={handleInputChange}
            value={name_other_cost}
            error={errors.name_other_cost}
          >
          </LabelGroup>
        </div>
        <div>
          <NumericFormat
            allowNegative={false}
            thousandSeparator={true}
            decimalScale={decimal_values_precision || 4}
            decimalSeparator="."
            placeholder={"0"}
            customInput={LabelGroup}
            onValueChange={updateItemValue}
            name={"net_weight_kilo_other_cost"}
            value={net_weight_kilo_other_cost}
            onChange={(e) => handleRegex(e, "números", Regex?.numeros)}
            tag={"Peso en Kilos"}
            size={100}
            desicion={false}
            maxLength={34}
            error={errors.net_weight_kilo_other_cost}
            required={true}
          >
          </NumericFormat>
        </div>
      </SimpleGrid>

      <SimpleGrid minChildWidth="200px" spacing="10px" className="mt-3 mb-3">
        <div>
          <NumericFormat
            allowNegative={false}
            thousandSeparator={true}
            decimalScale={decimal_values_precision || 4}
            decimalSeparator="."
            customInput={LabelGroup}
            name={"total_calculated_other_cost"}
            onValueChange={updateItemValue}
            value={total_calculated_other_cost}
            onChange={(e) => handleRegex(e, "números", Regex?.numeros)}
            required={true}
            placeholder={"0"}
            tag={"Valor Total en US$"}
            size={100}
            desicion={false}
            maxLength={34}
            error={errors.total_calculated_other_cost}
          >
          </NumericFormat>
        </div>
        <div></div>
      </SimpleGrid>

      <div className="mb-3 ms-5">
        <Box
          display="flex"
          alignItems="center"
          justifyContent="flex-end"
          flexWrap={"wrap"}
        >
          <ButtonStyled bgColor={"#bababa"} onClick={onCloseModal}>
            Cerrar
          </ButtonStyled>

          <ButtonStyled onClick={createOtherCost}>Agregar</ButtonStyled>
        </Box>
      </div>
    </>
  );
};

export default FormAddOtherCostOP;
